import { Router } from '@angular/router';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {

  isMobile: boolean = false;
  isSideMenuToggled: boolean = true;
  selectedTab: number = 0;

  constructor(
    private router:Router,
    public platform: Platform
  ) {
    // if(this.platform.ANDROID || this.platform.IOS) {
    //   this.isSideMenuToggled = false;
    // }
  }

  ngOnInit() {
    this.isMobile = this.platform.ANDROID || this.platform.IOS;
    const currentRoute = this.router.url;
    if (currentRoute.includes('business')) {
      this.selectedTab = 1; // Select "My Business" tab
    } else {
      this.selectedTab = 0; // Default to "My Customers" tab
    }
  }
  route(){
    this.selectedTab = 1;
    this.router.navigate(["view/mybusiness"])
  }

  customroute(){
    this.selectedTab = 0;
    this.router.navigate(["view/mycustomers"])
  }

  toggleMenu() {
    this.isSideMenuToggled = !this.isSideMenuToggled;
  }

  isRouteActive(route: string) {
    return this.router.url.includes(route);
  }
}
